import React, { FC } from "react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { UsersRound } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ChannelUserAvatarProps {
  name?: string | null;
  className?: string;
  isGroup?: boolean;
}

const ChannelUserAvatar: FC<ChannelUserAvatarProps> = ({
  name,
  className,
  isGroup = false,
}) => {
  const { t } = useTranslation();

  return (
    <Avatar className={cn("size-8 rounded-lg", className)}>
      <AvatarFallback className="bg-eathy-comfort-4/50 text-eathy-comfort-1 rounded-lg font-medium">
        {isGroup ? (
          <>
            <UsersRound
              className="text-eathy-comfort-1 size-4"
              aria-hidden="true"
            />
            <span className="sr-only">{t("chats.groupChat")}</span>
          </>
        ) : (
          name
            ?.split(" ")
            .slice(0, 2)
            .map((word) => word.charAt(0))
            .join("")
            .toUpperCase()
        )}
      </AvatarFallback>
    </Avatar>
  );
};

export default ChannelUserAvatar;
